module.exports = __webpack_public_path__ + "img/icon-payroll.456fbf2e.png";